import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import ForgetPassword from '../views/ForgetPassword.vue'
import Nofound from '../views/Nofound.vue'
import Member from '../views/Member.vue'
import Member2 from '../views/Member2.vue'
import Infor from '../components/Infor.vue'
import InComfor from '../components/InComfor.vue'
import Award from '../components/award.vue'
import account from '../components/account'
import Apply from '../components/apply'
import Upgrade from '../components/upgrade'
import Declear from '../components/declear'
import DeclarRecord from '../components/DeclarRecord'
import Record from '../components/record'
import Performance from '../components/performance'

import News from '../components/news'
import Feedback from '../views/Feedback'
import myform from '../components/myform'
import word_1 from '../components/word/word_1'
import applymembership from '../components/Modal/applymembership.vue'
import Performancedeclaration from '../components/Modal/Performancedeclaration'
import expert from '../views/expert'
import Reviewrecords from '../components/Reviewrecords'
import Awardreview from '../components/Awardreview'
import expertMember from '../views/expertMembers'
import uploadAppendix from '../components/uploadAppendix'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    component: Login
}, {
    path: '/login',
    component: Login
},
    {
        path: '/register',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: Register
    },
    {
        path: '/forgetPassword',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: ForgetPassword
    },
    {
        path: '/nofound',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: Nofound
    }, {
        path: '/feedback',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: Feedback
    },
    {
        path: '/form',
        component: myform
    },
    {
        path: '/word_1',
        component: word_1
    },
    {
        path: '/applymembership',
        component: applymembership
    },
    {
        path: '/Performancedeclaration',
        component: Performancedeclaration
    },
    {
        path: '/expert',
        component: expert
    },
    {
        path: '/expertmember',
        component: expertMember,
        children: [
            {
                path: 'Reviewrecords',
                component: Reviewrecords
            },
            {
                path: 'Awardreview',
                component: Awardreview
            }
        ]
    },
    {
        path: '/member',
        component: Member,
        children: [{
            path: 'infor',
            component: Infor
        },
            {
                path: 'award',
                component: Award
            },
            {
                path: 'apply',
                component: Apply
            },
            {
                path: 'upgrade',
                component: Upgrade
            },
            {
                path: 'declear',
                component: Declear
            },
            {
                path: 'Declar_record',
                component: DeclarRecord
            },
            {
                path: 'uploadAppendix',
                component: uploadAppendix
            },
            {
                path: 'record',
                component: Record
            },
            {
                path: 'performance',
                component: Performance
            },

            {
                path: 'news',
                component: News
            },
            {
                path: 'account',
                component: account
            },
        ]
    },
    {
        path: '/memberinfo',
        component: Member2,
        children: [{
            path: 'infor',
            component: InComfor
        },
        ]
    },
    {
        path: '*', // 页面不存在的情况下会跳到404页面
        redirect: '/nofound',
        hidden: true
    }
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


const router = new VueRouter({
    routes
})

//路由导航守卫
router.beforeEach((to, from, next) => {
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
    if (to.path == '/' || to.path == '/forgetPassword' || to.path == '/register' || to.path == '/word_1' || to.path == '/expert') {
        next()
    } else {
        const tokenstr = window.localStorage.getItem('TOKEN')
        if (tokenstr == null) {
            next('/')
        }
    }
    next()
})

export default router
